/**
 * Referans sayaçlı gövde (body) scroll kilidi.
 *
 * Birden fazla katman (mobil menü, kullanıcı dropdown'ı, dialog) aynı anda
 * kilit isteyebildiği için basit "hidden yap / eski değeri geri koy" yaklaşımı
 * yanlış sonuç verir: ikinci katman kapanırken birinci hâlâ açıkken kilidi
 * kaldırır ya da `overflow: hidden` gövdede takılı kalır. Bu yardımcı, açık
 * kilit sayısını takip eder ve yalnızca son kilit bırakıldığında orijinal
 * stilleri geri yükler.
 */

let lockCount = 0;
let originalOverflow = "";
let originalPaddingRight = "";

export function lockBodyScroll(): void {
  if (typeof document === "undefined") return;
  const body = document.body;

  lockCount += 1;
  if (lockCount > 1) return;

  originalOverflow = body.style.overflow;
  originalPaddingRight = body.style.paddingRight;

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  body.style.overflow = "hidden";
  if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
}

export function unlockBodyScroll(): void {
  if (typeof document === "undefined") return;
  if (lockCount === 0) return;

  lockCount -= 1;
  if (lockCount > 0) return;

  const body = document.body;
  body.style.overflow = originalOverflow;
  body.style.paddingRight = originalPaddingRight;
}

/** Test/HMR güvenliği: tüm kilitleri sıfırlar. */
export function resetBodyScrollLock(): void {
  lockCount = 0;
  if (typeof document === "undefined") return;
  document.body.style.overflow = originalOverflow;
  document.body.style.paddingRight = originalPaddingRight;
}
